import { rollBeamHit, rollProjectileHit, rollProjectileDamage, beamDiceCount, heavyGraserDiceCount, buildResults } from "data/salvoTools"

export default function BoardingResolver() {
    return <div style={{ borderRadius: 10, backgroundColor: "#f7f7f7", padding: 20 }}> Boarding Salvo Resolver </div>
}